module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo-album-banner"
  }, [_c('nut-swiper', {
    ref: "demo5",
    attrs: {
      "direction": "horizontal",
      "swiperData": _vm.dataImgItem,
      "lazyLoad": true,
      "paginationVisible": true
    }
  }, _vm._l((_vm.dataImgItem), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "nut-swiper-slide"
    }, [(item.type === 1) ? _c('coupon-video', {
      attrs: {
        "obj": item
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 0) ? _c('img', {
      staticClass: "nut-img-lazyload",
      staticStyle: {
        "max-width": "100%",
        "max-height": "100%"
      },
      attrs: {
        "data-src": item.url
      }
    }) : _vm._e()], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e76057e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cardCoupons/component/couponSwiper.vue
// module id = 442
// module chunks = 1